export const openSpring = { type: "spring", stiffness:500, damping: 30 };
export const closeSpring = { type: "spring", stiffness: 300, damping: 35 };
